import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

const initialState = {
    isMobileResponsive: false,
    detailTabMenu:'asset-info',
    detailSideTabMenu:'basic-information',
    assetListTabMenu:null,
    allVulnerabilityNavigateType: null,
    allVulnerabilityNavigateName: null,
    techCategoryNavigateFilter: null,
    isErrorBoundaryActive: false,
    currentPath: null,
    previousPath: null,
};

export const utilSlice = createSlice({
    name: 'utilSlice',
    initialState,
    reducers: {
        setResponsive: (state, action) => {
            state.isMobileResponsive = action.payload;
        },
        setdetailTabMenu: (state, action) => {
            state.detailTabMenu = action.payload;
        },
        setDetailSideTabMenu: (state, action) => {
            state.detailSideTabMenu = action.payload;
        },
        setAssetListTabMenu: (state, action) => {
            state.assetListTabMenu = action.payload;
        },
        setActivePageKey: (state, action) => {
            state.activePageKey = action.payload;
        },
        setAllVulnerabilityNavigateType: (state, action) => {
            state.allVulnerabilityNavigateType = action.payload;
        },
        setAllVulnerabilityNavigateName: (state, action) => {
            state.allVulnerabilityNavigateName = action.payload;
        },
        setTechCategoryNavigaterFilter: (state, action) => {
            state.techCategoryNavigateFilter = action.payload;
        },
        setIsErrorBoundaryActive: (state, action) => {
            state.isErrorBoundaryActive = action.payload;
        },
        updatePath: (state, action) => {
            state.previousPath = state.currentPath;
            state.currentPath = action.payload;
        },
    },
    extraReducers: (builder) => {
       
    }
});

export const {
    setResponsive,
    setdetailTabMenu,
    setDetailSideTabMenu,
    setAssetListTabMenu,
    setActivePageKey,
    setAllVulnerabilityNavigateType,
    setAllVulnerabilityNavigateName,
    setTechCategoryNavigaterFilter,
    setIsErrorBoundaryActive,
    updatePath
} = utilSlice.actions;

export default utilSlice.reducer;

